module.exports = __webpack_public_path__ + "img/circle_shape.a991ee93.svg";